import { useStyles } from '@webapps/styles';
import GenerateBilling from './GenerateBilling';
import AmountSection from './AmountSection';
import BillingList from './BillingList';

const Accounting = ({ opcoRecord, refetch }) => {
  const { classes, css, cx, global } = useStyles(styles);


  return (
    <div className={cx(global.fcjs, classes.gap)}>
      {/* <AmountSection opcoRecord={opcoRecord} />
      <BillingList opcoRecord={opcoRecord} refetch={refetch} />
      <GenerateBilling opcoRecord={opcoRecord} refetch={refetch} /> */}
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  gap: {
    gap: 20,
  }
});

export default Accounting;